import { Farm } from '@agroone/entities'
import { ActionCreator, ReducerTypes, on } from '@ngrx/store'
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import {
  addFarm,
  addFarmFailure,
  addFarmSuccess,
  clearFarms,
  loadFarms,
  loadFarmsFailure,
  loadFarmsSuccess,
  updateFarm,
  updateFarmFailure,
  updateFarmSuccess,
} from '../actions/farm.actions'
export type FarmState = EntityState<Farm>

export const farmAdapter: EntityAdapter<Farm> = createEntityAdapter<Farm>()

export const initialFarmState: FarmState = farmAdapter.getInitialState({
  ids: [],
})

export const farmOns: ReducerTypes<FarmState, ActionCreator[]>[] = [
  on(loadFarms, (state) => ({
    ...state,
  })),
  on(loadFarmsSuccess, (state, action) => farmAdapter.setAll(action?.farms, { ...state })),
  on(loadFarmsFailure, (state) => ({
    ...state,
  })),

  // CREATE
  on(addFarm, (state) => ({
    ...state,
  })),
  on(addFarmSuccess, (state, action) =>
    farmAdapter.addOne(action.payload.farm, {
      ...state,
      message: 'Farm has been added',
      error: undefined,
    }),
  ),
  on(addFarmFailure, (state) => ({
    ...state,
    error: 'Oups, Farm has not  been added ...',
  })),

  // UPDATE
  on(updateFarm, (state) => ({
    ...state,
  })),
  on(updateFarmSuccess, (state, action) =>
    farmAdapter.upsertOne(action?.payload?.farm, {
      ...state,
      message: 'Farm has been added',
      error: undefined,
    }),
  ),
  on(updateFarmFailure, (state) => ({
    ...state,
    error: 'Oups, Farm has not  been updated ...',
  })),
  on(clearFarms, () => initialFarmState),
]
